module.exports = __webpack_public_path__ + "static/media/ua_yahoo.dab5b451.png";